import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//申请发票(带token)
export function applyInvoice(data) {
    return fetch({
        url: config.WEB_APPLYINVOICE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//历史发票
export function invoiceList(data) {
    return fetch({
        url: config.WEB_INVOICELIST_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//发票详情
export function invoiceInfoById(data) {
    return fetch({
        url: config.WEB_INVOICEINFO_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}